import { createContext, useContext } from "react"

export type Theme = "dark" | "light"

export const colorArray = ["default", "mono", "rose", "sky"] as const;
export type Color = typeof colorArray[number];

export type ThemeProviderState = {
  theme: Theme
  color: Color
  toogleTheme: () => void
  toogleColor: (color: Color) => void
}

export const systemTheme: Theme = window.matchMedia("(prefers-color-scheme: dark)").matches
  ? "dark"
  : "light"

export const initialState: ThemeProviderState = {
  theme: systemTheme,
  color: "default",
  toogleTheme: () => null,
  toogleColor: () => null
}

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export const useTheme = () => useContext(ThemeProviderContext)
